// extracted by mini-css-extract-plugin
export default {"loadingContainer":"loading_loadingContainer__Fp8WI","spinner":"loading_spinner__MFY56","dot":"loading_dot__SVrh8","bounce":"loading_bounce__2atwk"};